import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import PrintNewsEvent from "../../../components/utilities/print/default/news-event";
// middlewares
import AuthMiddleware from "../../../reducers/auth/middleware";
import NewsEventMiddleware from "../../../middleware/modules/news/news-event";

const mapStateToProps = ({ auth, newsEvent }) => ({
  isAuthenticated: auth.isAuthenticated,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  isProcessing: newsEvent.isProcessing,
  dataPrint: newsEvent.printNewsEvent,
  requestPrint:newsEvent.requestPrint
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrint: (id) => NewsEventMiddleware.getPrint(id),
    },
    dispatch
  );
};

class NewsEventContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    requestPrint:PropTypes.bool
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
    requestPrint:false
  };

  UNSAFE_componentWillMount() {
    this.props.getPrint(this.props.id);
  }

  render() {
    return <PrintNewsEvent {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsEventContainer);
